module.exports = __webpack_public_path__ + "img/背景.73d8b0c0.jpg";